import { z } from 'zod';
const AddressSchema = z.object({
  streetNumber: z.string({
    required_error: 'streetNumber is required',
    invalid_type_error: 'streetNumber must be a string'
  }),
  streetName: z.string({
    required_error: 'streetName is required',
    invalid_type_error: 'streetName must be a string'
  }),
  suburb: z.string({
    required_error: 'suburb is required',
    invalid_type_error: 'suburb must be a string'
  }),
  postCode: z.string({
    required_error: 'postCode is required',
    invalid_type_error: 'postCode must be a string'
  }),
  state: z.string({
    required_error: 'state is required',
    invalid_type_error: 'state must be a string'
  }),
  country: z.string({
    required_error: 'country is required',
    invalid_type_error: 'country must be a string'
  })
});

type Address = ReturnType<typeof AddressSchema.parse>;

export { AddressSchema, type Address };
